import React from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import { Typography } from '@mui/material'
import { Column } from 'src/components/Layout/Styled'
import ProgressBar from './ProgressBar'

const Header = () => {
  const { courseDetail } = useSelector(
    (state) => ({
      progress: state.classEnroll.progress,
      courseDetail: state.classEnroll.enrollProps?.courseDetail,
    }),
    shallowEqual
  )

  return (
    <Column sx={{ mt: { lg: '60px', xs: '24px' } }}>
      <Typography sx={{ typography: { sm: 'h4', xs: 'h5' } }}>
        สมัครอบรม {courseDetail?.thaiName || courseDetail?.englishName}
      </Typography>
      <ProgressBar />
    </Column>
  )
}

export default Header
